// pages/ProjectUser.js
import React, { useEffect, useState } from 'react';
import Container from '../layouts/Container';
import { toast } from 'react-toastify';
import { getAllProjectUsers, activate, deactivate, deleteUser } from '../services/project/userService';
import { ProjectUsersTable } from '../components/UsersTable';
import { useProjects } from '../context/ProjectContext';

function ProjectUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { projects } = useProjects();

  useEffect(() => { fetchUsers(); }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getAllProjectUsers(); // returns { success, users? / projectUsers? }
      if (!res?.success) {
        toast.error(res?.data?.errorMessage || 'Error fetching users.');
        return;
      }
      const list = res.users ?? res.projectUsers ?? [];
      setUsers(list);
    } catch (err) {
      console.error('Error fetching users:', err);
      toast.error(err?.response?.data?.errorMessage || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async (user) => {
    if (!window.confirm(`Activate ${user.username || `${user.firstName || ''} ${user.lastName || ''}`.trim()}?`)) return;
    try {
      const response = await activate(user.id);
      toast.success(response.message);
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.errorMessage || 'Something went wrong');
    }
  };

  const handleDeactivate = async (user) => {
    if (!window.confirm(`Deactivate ${user.username || `${user.firstName || ''} ${user.lastName || ''}`.trim()}?`)) return;
    try {
      const response = await deactivate(user.id);
      toast.success(response.message);
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.errorMessage || 'Something went wrong');
    }
  };

  const handleDelete = async (user) => {
    if (!window.confirm(`Delete ${user.username || `${user.firstName || ''} ${user.lastName || ''}`.trim()}?`)) return;
    try {
      const response = await deleteUser(user.id);
      toast.success(response.message);
      fetchUsers();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.errorMessage || 'Something went wrong');
    }
  };

  return (
    <Container>
      <h2 style={{ marginBottom: '1rem' }}>All Project Users</h2>
      {loading ? <p>Loading...</p> : (
        <ProjectUsersTable
          users={users}
          handleActivate={handleActivate}
          handleDeactivate={handleDeactivate}
          handleDelete={handleDelete}
          projects={projects}
          onReassigned={fetchUsers}
        />
      )}
    </Container>
  );
}

export default ProjectUsers;
